import { SettingsPage } from '@apps-common/apps/my-monitoring/pages/settings/Index'

export const Settings = () => <SettingsPage />
